import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, finalize, map } from "rxjs/operators";
import { Globals } from "../../app.globals";

@Injectable()
export class LookupValuesService {
    private apiUrl = "/api/settings/lookupvalues";

    constructor(private http: HttpClient, private globals: Globals) {}

    getLookupValues(type: string): Observable<LookupValue[]> {
        this.globals.showSpinner();
        return this.http.get(this.apiUrl + "/getall/" + type).pipe(
            map((res) => res as LookupValue[]),
            catchError(this.handleError),
            finalize(() => this.globals.hideSpinner())
        );
    }

    getActiveLookupValues(type: string): Observable<LookupValue[]> {
        this.globals.showSpinner();
        return this.http.get(this.apiUrl + "/getallactive/" + type).pipe(
            map((res) => res as LookupValue[]),
            catchError(this.handleError),
            finalize(() => this.globals.hideSpinner())
        );
    }

    getLookupValue(lookupValueId: number): Observable<LookupValue> {
        return this.http.get(this.apiUrl + "/" + lookupValueId).pipe(
            map((res) => res as LookupValue),
            catchError(this.handleError)
        );
    }

    addLookupValue(lookupValues: LookupValue[]): Observable<any> {
        return this.http.post(this.apiUrl, lookupValues).pipe(
            catchError(this.handleError)
        );
    }

    deleteLookupValue(lookupValueId: number): Observable<any> {
        return this.http.delete(this.apiUrl + "/delete/" + lookupValueId).pipe(
            catchError(this.handleError)
        );
    }

    deactivateLookupValue(lookupValueId: number): Observable<any> {
        return this.http
            .delete(this.apiUrl + "/deactivate/" + lookupValueId)
            .pipe(
                catchError(this.handleError)
            );
    }

    activateLookupValue(lookupValueId: number): Observable<any> {
        return this.http
            .delete(this.apiUrl + "/activate/" + lookupValueId)
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: Response): Observable<any> {
        return throwError(
            error || "Server error, please refresh and try again"
        );
    }
}

export class LookupValue {
    id: number;
    type: string;
    name: string;
    status: string;
    active: string;
    inUse?: boolean;
    isDefault?: boolean;
}
